<template>
  <div>
    <div @click="triggerClick">
      <el-button v-if="!$slots.default" type="primary">{{ selected.name || '选择地址' }}</el-button>
      <slot></slot>
    </div>
    <Dialog :title="title" :padding="0" v-model="dialogVisible" :footer="false" @close="close">
      <Drawer :title="title" v-model="drawerVisible">
        <div class="input-address">
          <el-input type="textarea" maxlength="15" placeholder="请输入地址" v-model.trim="inputAddress"
            show-word-limit></el-input>
          <div class="search-button selected" @click="selectedInput">选择</div>
        </div>
      </Drawer>

      <div class="address-box" v-loading="loading">
        <div class="location" @click="goselfLocation">
          <img :src="location" alt srcset>
        </div>
        <div class="select-box">
          <el-input v-model="searchValue" style="width: 400px" @input="querySearch" placeholder="搜索其他地点"
            prefix-icon="el-icon-search" :trigger-on-focus="false"></el-input>
          <div class="map-search-content" v-show="searchValue">
            <div class="no-search" @click="showInputAddress">+没有找到想要的地点</div>
            <p v-if="search.tips.length == 0" class="noAddress">未找到匹配的地址</p>
            <div class="search-item flex-center-side" v-for="(item, index) in search.tips" :key="index">
              <div @click="querySearched(index, item)">
                <p class="address over-omit">{{ item.name }}</p>
                <p class="detailed-address over-omit">{{ item.address }}</p>
              </div>
              <div class="search-button selected" @click="querySearched(index, item, true)">选择</div>
            </div>
          </div>
        </div>
        <!-- 地图 -->
        <div class="map-container">
          <div id="map" style="width:100%;height: 100%"></div>
        </div>
        <!-- 底部信息栏 -->
        <div class="map-select-container flex-center-side" v-if="selected.name">
          <div class="map-select">
            <p class="address over-omit" style="width:328px">{{ selected.name }}</p>
            <p class="detailed-address over-omit" style="width:328px">{{ selected.address }}</p>
          </div>
          <el-button type="primary" size="small" class="select-button" @click="bottomSelected">选择</el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import dinwei from "@imgs/dinwei.png";
import dinweisel from "@imgs/dinweisel.png";
import lodash from 'lodash';

export default {
  name: "selectAddress",
  components: {},
  model: {
    prop: "value",
    event: "confirm"
  },
  props: {
    title: {
      type: String,
      default: '选择位置'
    },
    value: {
      type: Object,
      default: () => {
        return {
          name: "", //名字
          address: "", //地址精确
          point: [] //经纬度
        };
      }
    }
  },
  data() {
    return {
      geocoder: {},
      location: dinwei,
      loading: false,
      dialogVisible: false,
      checkAll: false,
      searchValue: "",
      map: null,
      mark: "",
      inputAddress: "",
      drawerVisible: false,
      search: {
        city: null,
        txt: "",
        tips: [],
        selIndex: null
      },
      mapPlug: {
        mapPlaceSearch: null,
        mark: null
      },
      selected: {
        name: "",
        address: "",
        point: []
      },
      lngLat: ""
    };
  },
  mounted() { },
  methods: {
    /**
     * 打开地图弹窗
     */
    triggerClick() {
      this.dialogVisible = true;
      this.loading = false;
      this.clearData();
      this.searchValue = null;
      if (this.value && this.value.address) {
        this.selected = lodash.cloneDeep(this.value);
      }
      this.$nextTick(() => {
        this.initMap();
      });
    },
    showInputAddress() {
      this.drawerVisible = true;
    },
    /**
     * 搜索
     */
    querySearch(keyword) {
      this.search.selIndex = null;
      // this.mapPlug.mapPlaceSearch.setCityLimit(true);
      // this.mapPlug.mapPlaceSearch.setCity(this.search.city);
      this.mapPlug.mapPlaceSearch.search(keyword, (status, result) => {
        if (status === 'complete') {
          this.search.tips = result.tips.map(ele => {
            return {
              ...ele,
              address: typeof ele.address === 'string' ? ele.address : ''
            }
          });
        } else {
          this.search.tips = [];
        }
      });
    },
    /**
     * 选择搜索地址
     */
    querySearched(index, item, flag) {
      this.location = dinwei;
      this.search.selIndex = index;
      this.selected.name = item.name;
      this.selected.address = item.address;
      this.selected.point = [item.location.lng, item.location.lat];
      this.mapPlug.mark.setPosition(item.location);
      this.mapPlug.mark.setMap(this.map);
      this.map.setCenter(item.location);
      if (flag) {
        const clone = lodash.cloneDeep(this.selected);
        this.$emit("confirm", clone);
        this.dialogVisible = false;
        this.map.destroy();
      }
    },
    /**
     * 手动输入地址点击选择
     */
    selectedInput() {
      this.selected.point = [];
      this.selected.address = "";
      this.selected.name = this.inputAddress;
      const clone = lodash.cloneDeep(this.selected);
      this.$emit("confirm", clone);
      this.dialogVisible = false;
      this.drawerVisible = false;
      this.inputAddress = null;
      this.map.destroy();
    },
    /**
     * 地图下方地址点击选择
     */
    bottomSelected() {
      const clone = lodash.cloneDeep(this.selected);
      this.$emit("confirm", clone);
      this.location = dinwei;
      this.dialogVisible = false;
      this.map.destroy();
    },
    /**
     * 数据处理
     */
    clearData() {
      this.search = {
        city: null,
        txt: "",
        tips: [],
        selIndex: null
      };
      this.fence = this.$options.data.call(this).fence;
      this.location = dinwei;
    },
    close() {
      this.clearData();
      this.map.destroy();
      this.searchValue = null;
      this.dialogVisible = false;
      this.drawerVisible = false;
    },
    /**
     * 定位到自己的位置
     */
    goselfLocation() {
      this.location = dinweisel;
      this.map.setCenter(this.lngLat);
      this.mark.setPosition(this.lngLat);
      this.getAddress({ lng: this.lngLat[0], lat: this.lngLat[1] });
    },
    /**
     * 获取位置信息-传入经纬度
     */
    getAddress(lnglat) {
      this.geocoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.regeocode) {
          const address = result.regeocode.addressComponent;
          if (address.building) {
            this.selected.name = address.building;
          } else {
            this.selected.name =
              address.township + address.street + address.streetNumber;
          }
          this.selected.township = address.township;
          this.selected.address = result.regeocode.formattedAddress;
          this.selected.point = [lnglat.lng, lnglat.lat];
        }
      });
    },
    initMap() {
      AMapLoader.load({
        key: this.amapKey,
        version: "2.0",
        plugins: [
          "AMap.Geolocation",
          "AMap.CitySearch",
          "AMap.AutoComplete",
          "AMap.ToolBar",
          "AMap.Geocoder",
          "AMap.Geolocation"
        ]
      })
        .then(AMap => {
          this.map = new AMap.Map("map");
          this.geocoder = new AMap.Geocoder();
          this.map.setZoom(14);
          const icon = new AMap.Icon({
            size: new AMap.Size(36, 40),
            image: mapIcon,
            imageSize: new AMap.Size(36, 40),
            imageOffset: new AMap.Pixel(0, 0)
          });
          this.mark = new AMap.Marker({
            icon,
            offset: new AMap.Pixel(-18, -36),
            draggable: true
          });
          this.mapPlug.mapPlaceSearch = new AMap.AutoComplete({});
          this.mark.on("dragend", e => {
            this.getAddress(e.lnglat);
          });
          this.map.on("complete", () => {
            if (!this.selected.address) {
              var options = {
                showButton: false, //是否显示定位按钮
                showMarker: false
              };
              let lngLat;
              let citySearch = new AMap.CitySearch();
              citySearch.getLocalCity((status, result) => {
                if (status === "complete" && result.info === "OK") {
                  this.search.city = result.adcode;
                  lngLat = result.bounds.getCenter();
                  this.lngLat = [lngLat.lng, lngLat.lat];
                  this.map.setCenter(this.lngLat);
                  this.mark.setPosition(this.lngLat);
                }
              });
            } else {
              const point = new AMap.LngLat(
                this.selected.point[0],
                this.selected.point[1]
              );
              this.map.setCenter(point);
              this.mark.setPosition(point);
              this.location = dinwei;
            }
          });
          this.mark.setMap(this.map);
          this.mapPlug.mark = this.mark;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
const mapIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAYAAACb3CikAAAAAXNSR0IArs4c6QAAAsdJREFUWEftmDtoU2EUx//nSxol1FJBREeH4mOQmpprRdqSG+zgc4lLHXxMgpv4GHTUwSJugpOPwS528TlUeoMGabzXxOCgFgdHRQotWoKmyT1yY25Mbu+rqaF36F2/c873+84r54SwpI8pLmOACAfB2Augh4H1hgkCZgF8BmGKGc80BRmA2K958iu4J8kpZlwFsNWnzjQRrryZpHE/8p4g0jBvwQLGQOj3Y3CRDCOLDoyoE/TFTd8VJL6fh6gC40UbWoL4pzTDIaS0F/TSyY4jSA1iAkBkmRCmeolDGHaCsQWphqMM9T94wvqGGYQh2YXJHiTBUy3nhJf7GFk1TUbFNX2LQGrV8dDL3nLOiXDMWk0WECZJxscllGirPNOqgu2NfaYJJC7zIAGOmd14675+YCQF7Kh1lQ/TwNg48Drrj42BIU2hV6Z0E4iU5FEwLniZOnMaOHXcXuruA+D2HS8L1VY8qk7SJXsQmQ3CATczhiduXnO/6NxlX57JqAoNOoF8BbDJ7ZpbN4Ddu9xB3r4Dzp739Mo3VaHNtiBxmX8RsMbNRPoJEI26X1IsAonD7jIM/NYUWhtsEEnmYIRGCkyyJvk6GBe90qzt5RuYhgYEpMUbIQnIj97f7JCCMAZUQYIyGBkwgRgVzfINxPBswgRinWhsbCu+YDV32frKeQhcXbh6LGNDBoQsM562beV0avuSzPX9VlXIc3N0stOyYj2HVkEsvl0NjTXZVswjvb293ZFIZKOu690AoqJLS5tw+o94AkBRCDFXKpW+FwqFOa8hy3Z4dlPq6+uLhsPhnZVKpfpXlfmJLu15A8iBxrNQKDRbLpff53K5oheQ7/KNxWIDQohOq0GxTn0Eog4wL+g/paPWc13X5/P5fKbtINR57wTRtiPMnx7z/Mn7bQdxCo3bS9sSGvNCa7Iyc0QIIXRd14mo1Gqy/gHyZWk4Yl7zgQAAAABJRU5ErkJggg==";
</script>

<style lang='scss' scoped>
.location {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 30;
  cursor: pointer;

  img {
    width: 50px;
    height: 50px;
  }
}

.input-address {
  border-top: 1px solid #e4e4e4;
  width: 100%;
  height: calc(90vh - 50px);
  box-sizing: border-box;
  font-size: 14px;
  padding: 30px;
  position: relative;

  ::v-deep .el-textarea__inner {
    height: 200px;
  }

  .selected {
    width: 180px;
    height: 46px;
    line-height: 46px;
    margin: 30px auto;
    cursor: pointer;
  }
}

.address-box {
  width: 100%;
  height: 80%;
  box-sizing: border-box;
  font-size: 14px;
  position: relative;

  .select-box {
    position: absolute;
    top: 20px;
    left: 175px;
    z-index: 20;

    ::v-deep .el-input__suffix-inner {
      line-height: 40px;
      color: #3642ff;
      padding-right: 15px;
    }

    ::v-deep .el-input--suffix .el-input__inner {
      padding-right: 50px;
    }

    .map-search-content {
      width: 400px;
      height: 262px;
      margin-top: 10px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      overflow-y: auto;
      cursor: pointer;

      .noAddress {
        color: #888888;
        line-height: 120px;
        text-align: center;
      }

      .no-search {
        padding-top: 20px;
        width: 100%;
        text-align: center;
        color: #3642ff;
      }

      .search-item {
        width: 100%;
        height: 74px;
        box-sizing: border-box;
        padding: 15px 20px;

        &:hover {
          opacity: 0.8;
          background: #fafafa;
          color: #3642ff;
        }
      }

      .search-item:hover .address {
        color: #3642ff;
      }
    }
  }

  .map-container {
    width: 100%;
    height: calc(90vh - 50px);
    position: relative;
  }

  .map-select-container {
    position: absolute;
    bottom: 30px;
    left: 116px;
    width: 518px;
    height: 88px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    filter: blur(0px);
    box-sizing: border-box;
    padding: 20px;
    background-color: #ffffff;

    .map-select {
      width: 328px;
    }
  }
}

p {
  margin: 0;
  padding: 0;
}

.address {
  width: 242px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;

  margin-bottom: 4px;
}

.detailed-address {
  width: 241px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
}

.search-button {
  width: 70px;
  height: 34px;
  background: #3642ff;
  border-radius: 4px;
  filter: blur(0px);
  line-height: 34px;
  text-align: center;
  color: #fff;
}

// 超出一行显示省略号
.over-omit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.crumb-item {
  color: #333;
  cursor: pointer;
}

.del-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// flex布局
.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-column {
  @extend .flex;
  flex-direction: column;
}

.flex-column-center {
  @extend .flex-column;
  align-items: center;
}

.flex-center {
  @extend .flex;
  align-items: center;
}

.flex-stretch {
  @extend .flex;
  align-items: stretch;
}

.flex-line {
  @extend .flex;
  align-items: baseline;
}

.flex-center-center {
  @extend .flex-center;
  justify-content: center;
}

.flex-center-side {
  @extend .flex-center;
  justify-content: space-between;
}

.flex-stretch-center {
  @extend .flex-stretch;
  justify-content: center;
}

.flex-stretch-side {
  @extend .flex-stretch;
  justify-content: space-between;
}

::v-deep .el-input__validateIcon {
  display: none;
}

:deep(.amap-marker-label) {
  border: none;
  padding: 0;
}

:deep(.amap-icon) img {
  width: 100%;
  height: 100%;
}

:deep(.amap-logo) {
  display: none !important;
}

:deep(.amap-copyright) {
  display: none !important;
}</style>
